/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "add-circle-big",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#CCCCCC"
            },
            "addCircleBig": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "37.7",
            "height": "37.7"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 37.7 37.7", className: "add-circle-big", width: this.props.width, height: this.props.height, style: this.props.addCircleBig },
            _react2["default"].createElement("path", { className: "st0", d: "M20.9 8.6h-4.1v8.2H8.6v4.1h8.2v8.2h4.1v-8.2h8.2v-4.1h-8.2z", style: this.props.st0 }),
            _react2["default"].createElement("path", { className: "st0", d: "M18.8 0C8.5 0 0 8.5 0 18.8s8.5 18.8 18.8 18.8 18.8-8.5 18.8-18.8S29.2 0 18.8 0zm0 33.7C10.7 33.7 4 27 4 18.8S10.7 4 18.8 4s14.8 6.7 14.8 14.8S27 33.7 18.8 33.7z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/add-circle-big.js